import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usePortal } from '../context/PortalContext';
import { tableService } from '../services/tableService';
import { TableSummary } from '../types';
import { formatCurrency, formatDateTime, getGameTypeLabel } from '../utils/formatters';

const TablesPage: React.FC = () => {
  const { selectedClub } = usePortal();
  const [tables, setTables] = useState<TableSummary[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!selectedClub?.id) {
      setTables([]);
      return;
    }

    setLoading(true);
    setError('');

    tableService
      .getClubTables(selectedClub.id)
      .then(setTables)
      .catch((nextError: any) => setError(nextError.message || 'Erro ao carregar mesas'))
      .finally(() => setLoading(false));
  }, [selectedClub?.id]);

  return (
    <section className="portal-section-card">
      <div className="portal-section-card__header">
        <div>
          <p className="portal-section-card__eyebrow">Operacao da mesa</p>
          <h3>Mesas do club</h3>
        </div>
      </div>

      {error ? <div className="portal-banner portal-banner--error">{error}</div> : null}

      <div className="portal-table-wrap">
        <table className="portal-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Jogo</th>
              <th>Blinds</th>
              <th>Buy-in</th>
              <th>Status</th>
              <th>Jogadores</th>
              <th>Acao</th>
              <th>Criada em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={9}>Carregando mesas...</td>
              </tr>
            ) : tables.length === 0 ? (
              <tr>
                <td colSpan={9}>Nenhuma mesa encontrada para este club.</td>
              </tr>
            ) : (
              tables.map((table) => (
                <tr key={table.id}>
                  <td>{table.name}</td>
                  <td>{getGameTypeLabel(table.game_type)}</td>
                  <td>{formatCurrency(table.smallBlind)} / {formatCurrency(table.bigBlind)}</td>
                  <td>{formatCurrency(table.minStack)} - {formatCurrency(table.maxStack)}</td>
                  <td>{table.status}</td>
                  <td>{table.currentPlayers}/{table.maxPlayers}</td>
                  <td>{table.actionTimeLimitSeconds}s</td>
                  <td>{formatDateTime(table.createdAt)}</td>
                  <td>
                    <Link className="portal-link-button" to={`/mesas/${table.id}`}>
                      Abrir detalhe
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default TablesPage;
